import { UseSetupCallbackCB, UserQuestionnaireType } from '@/components/decision-tree';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useAnswerQuestionnaire, useGetQuestionnaire } from '@/queries/questionnaire.queries';
import { getRouteLoadingScreen } from '@/utils';
import { useToast } from '@cmpsr/components';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

type useModalEditAnswerControllerProps = {
  surveyItemId: string | null;
  onCloseClick: () => void;
};

export default function useModalEditAnswerController({
  surveyItemId,
  onCloseClick,
}: useModalEditAnswerControllerProps) {
  const navigate = useNavigate();
  const toast = useToast();
  const { data: userQuestionnaire } = useGetQuestionnaire();

  const section = userQuestionnaire?.questionnaire?.sections.find((section) =>
    section.surveyItems.find((surveyItem) => surveyItem.id === surveyItemId)
  );

  const editQuestion = { surveyItemId: surveyItemId || '0', sectionId: section?.id || '0' };

  const uploadAnswerMutation = useAnswerQuestionnaire();

  const uploadAnswer: UseSetupCallbackCB = async (surveyItemId, answer): Promise<UserQuestionnaireType | null> => {
    try {
      const resultQuestionnaire = await uploadAnswerMutation.mutateAsync({ surveyItemId, answer });
      if (resultQuestionnaire?.nextSurveyItem?.surveyItemId) return resultQuestionnaire;

      toast({
        ...TOAST_DEFAULT_OPTIONS,
        description: 'Your answer has been updated.',
        status: 'success',
      });

      onCloseClick();
      navigate(getRouteLoadingScreen(ROUTE_DASHBOARD));

      return resultQuestionnaire;
    } catch (err) {
      const error = err as AxiosError;
      console.error(error);
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        description: "We couldn't save your answer. Please try again later.",
        status: 'error',
      });

      return userQuestionnaire ?? null;
    }
  };

  return { userQuestionnaire, editQuestion, uploadAnswer };
}
